import React from 'react';
import TailwindButton from '../TailwindButton';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
    
    // TODO: Send to error tracking service (Sentry, LogRocket, etc.)
    // Example:
    // if (window.Sentry) {
    //   window.Sentry.captureException(error, { contexts: { react: errorInfo } });
    // }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[rgba(5,6,9,0.95)]">
          <div className="text-center p-8">
            <div className="text-6xl font-display font-bold text-[#F5C467] mb-4">500</div>
            <h2 className="text-2xl font-display font-bold text-[#F7F3EA] mb-2">Something went wrong</h2>
            <p className="text-text-muted mb-6">Sorry, something went wrong.</p>
            <TailwindButton onClick={this.handleReset}>
              Try Again
            </TailwindButton>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;


